/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_ShipperInputs */

const en_orders_shipper = /** @type {(inputs: Orders_ShipperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shipper`)
};

const es_orders_shipper = /** @type {(inputs: Orders_ShipperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transportista`)
};

/**
* | output |
* | --- |
* | "Shipper" |
*
* @param {Orders_ShipperInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_shipper = /** @type {((inputs?: Orders_ShipperInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_ShipperInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_shipper(inputs)
	return es_orders_shipper(inputs)
});